class LnMobileProductHeader extends HTMLElement {
  #mediaQuery = window.matchMedia("(max-width: 749px)");
  #headerBlock;
  #originMarker;
  #observer = new MutationObserver(() => {
    if (
      !this.#headerBlock?.isConnected ||
      !this.#originMarker?.isConnected ||
      (this.#mediaQuery.matches && !this.contains(this.#headerBlock))
    ) {
      this.#initialize();
    }
  });

  connectedCallback() {
    const productGrid = this.closest("[data-product-grid-content]");
    if (productGrid) {
      this.#observer.observe(productGrid, { childList: true, subtree: true });
    }
    this.#mediaQuery.addEventListener("change", this.#handleBreakpointChange);
    queueMicrotask(() => this.#initialize());
  }

  disconnectedCallback() {
    this.#observer.disconnect();
    this.#mediaQuery.removeEventListener(
      "change",
      this.#handleBreakpointChange,
    );
  }

  #initialize() {
    const productGrid = this.closest("[data-product-grid-content]");
    const detailsContent = productGrid?.querySelector(
      ".product-details > .group-block > .group-block-content",
    );
    if (!detailsContent) return;

    if (this.#headerBlock?.isConnected && this.#originMarker?.isConnected) {
      this.#updatePosition();
      return;
    }

    const firstDetailsBlock = detailsContent.querySelector(
      ":scope > :not(.view-product-title)",
    );
    const headerBlock = this.#headerBlock?.isConnected
      ? this.#headerBlock
      : firstDetailsBlock;

    if (!headerBlock) return;

    this.#originMarker?.remove();
    this.#headerBlock = headerBlock;
    this.#originMarker = document.createComment("mobile-product-header-origin");
    if (this.contains(headerBlock)) {
      if (firstDetailsBlock) firstDetailsBlock.before(this.#originMarker);
      else detailsContent.append(this.#originMarker);
    } else {
      headerBlock.before(this.#originMarker);
    }
    this.#updatePosition();
  }

  #handleBreakpointChange = () => {
    this.#updatePosition();
  };

  #updatePosition() {
    if (!this.#headerBlock || !this.#originMarker) return;

    if (this.#mediaQuery.matches) {
      this.append(this.#headerBlock);
      return;
    }

    this.#originMarker.after(this.#headerBlock);
  }
}

if (!customElements.get("ln-mobile-product-header")) {
  customElements.define("ln-mobile-product-header", LnMobileProductHeader);
}
